import { render, staticRenderFns } from "./StaffNumbers.vue?vue&type=template&id=93521a84&"
import script from "./StaffNumbers.vue?vue&type=script&lang=js&"
export * from "./StaffNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports